export const NoDataFound = "Try adjusting your search and filter options to find what you're looking for."

export const BASE_URL = "https://api.ecosystems.vidhilegalpolicy.in/api/v1";